<template id="dc-vizlet">
  <section>
    <div class="text-center mr-2" v-if="dcViz.visibleFlag && dcViz.viztypeName === 'DC NumberDisplay' ">
      <div class="banner"><strong class="displayName">{{ dcViz.y1_axisDisplayName | uppercase }}</strong></div>
      <div v-if="dcViz.y1_metricUnit !=='' ">
        <div class="banner displayName" :id="id" ref="r1c1" :style="{ color: dcViz.colourscheme1, fontWeight: 'bold' }"></div>
<!--        <div class="banner">({{ dcViz.y1_metricUnit }})</div>-->
      </div>
    </div>

    <div class="text-center mr-2 mobile-hide" v-if="dcViz.visibleFlag && dcViz.viztypeName !=='DC NumberDisplay'">
      <div class="dcBanner" :id="id" ref="r1c1">
        <a class='reset'
           @click="resetChartFunc()"
           style='visibility: hidden;'>reset</a>
      </div>
    </div>


  </section>
</template>
<script>

import * as dc from 'dc'
//import axios from 'axios'
import {DcChartInfo} from '@/models'
import {bus} from "@/bus"

export default {
  name: "dc-vizlet",
  filters: {
    uppercase(value) {
      if (!value) return ''; // Handle null/undefined values
      return value.toString().toUpperCase();
    },
  },
  props: {
    dcViz: Object
  },
  watch: {
    $props: {
      handler() {
        //watch able to listen first level change not the second level change as a work
        //    around made separate variable for second listbox, date filter
        this.loadSummary();
      },
      deep: true,
      immediate: true,
    }
  },
  data: () => ({
    showModal: false,
    cmnt: "",
    id: `VIZ-${new Date().getTime()}`,
    res: "",
    levelOnePeriodData: [],
    annotations: [],
    filterPeriodLevel1: '',
    filterPeriodLevel2: 'quarterly',
    //filterPeriodLevel2: 'weekly',
    //filterPeriodLevel2: 'monthly',
    searching: false,
    annotationTitle: '',
    reportTitle: '',
    dataSqlId: '',
    viztypeClassName: '',
    homeData: {}
  }),
  computed: {},
  created() {
    this.loadSummary()
    bus.$on('banner-changed', (f) => {
      this.filterPeriodLevel1 = f['l1']
      this.filterPeriodLevel2 = f['l2']
      setTimeout(() => {
        //this.loadHomeConfig()
        //this.dcSummaryCharts()
      }, 1000)
    })
  },
  methods: {
    resetChartFunc() {
      dc.filterAll();
      dc.renderAll();
    },
    periodLOne: function () {
      this.filterPeriodLevel2 = 'quarterly'
      //this.filterPeriodLevel2 = 'weekly'
      //this.filterPeriodLevel2 = 'monthly'
      // this.dcSummaryCharts()
      //  this.updateReportData()
    },
    periodLTwo: function () {
      //this.dcSummaryCharts()
    },

    resetChart: function () {
      let divId = this.$refs.r1c1;
      divId.filterAll();
      dc.redrawAll();
    },

    loadSummary: function () {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.dcViz;
        //console.log("v from banner-dc-vizlet",v)

        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName
        let vizFunction = filter.viztypeFunctionName;

        let divId = this.$refs.r1c1;


        this.r2c1 = new DcChartInfo(1, this.dcViz, this.dcViz['visibleFlag'], this.dcViz, margin)


        // this.$commonFn.auditLog(homeData[0].menuSyspk,submenuParam,homeData[0].menuName,homeData[0].screenTitle, "GET", "Success")
        setTimeout(async () => {
          await this.$commonFn.renderDcChart(
              vizname,
              this.r2c1,
              divId,
              vizFunction
          );
          // dc.renderAll();
        }, 1000)


      })
    }
  }
};
</script>
<style scoped>
.dcBanner{
   width:16.5vw
}

@media (max-width: 767.98px) {
  .mobile-hide {
    display: none;
  }
}

@media (max-width: 1501px) and (min-width: 1301px) {
  .dcBanner{
    width:14vw
  }
}

@media (max-width: 1300px) {
  .dcBanner{
    width:11vw
  }
  .displayName{
    font-size: 11px;
  }

}
</style>